import React, { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import CourseCard from "@/components/CourseCard";
import { api } from "@/lib/api";

export default function Courses() {
  const [courses, setCourses] = useState([]);
  useEffect(() => { api.get("/courses").then(({ data }) => setCourses(data)); }, []);
  return (
    <PublicLayout>
      <section className="container-x pt-16 md:pt-24 pb-10">
        <div className="overline mb-4">Course catalog</div>
        <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter">Choose your AI advantage.</h1>
        <p className="mt-6 text-ink-600 max-w-2xl leading-relaxed">Every course is built around real workflows and real business outcomes — not theory. Pick where you are today and go deep.</p>
      </section>
      <section className="container-x pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="courses-grid">
          {courses.map((c) => <CourseCard key={c.course_id} course={c} />)}
        </div>
        {courses.length === 0 && <p className="text-ink-500">No courses published yet.</p>}
      </section>
    </PublicLayout>
  );
}
